import { Link } from 'react-router';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="ftr">
      <div className="ftr__inner">
        <div className="ftr__brand">
          <div className="ftr__logo">
            <svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true">
              <defs>
                <linearGradient id="ftr-logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%"   stopColor="#ff6b00" />
                  <stop offset="100%" stopColor="#e91e8c" />
                </linearGradient>
              </defs>
              <rect width="32" height="32" rx="8" fill="url(#ftr-logo-grad)" />
              <path d="M8 8h4v16H8zM20 8h4v16h-4zM12 8h4L20 24h-4z" fill="#ffffff" />
            </svg>
            <span className="ftr__word">Natya<span className="ftr__accent">X</span></span>
          </div>
          <p>Every movie, one subscription. Stream on any device.</p>
        </div>
        <nav className="ftr__cols" aria-label="Footer">
          <div>
            <h4>Watch</h4>
            <Link to="/browse">Browse</Link>
            <Link to="/browse?genre=action">Action</Link>
            <Link to="/browse?genre=drama">Drama</Link>
            <Link to="/browse?genre=comedy">Comedy</Link>
          </div>
          <div>
            <h4>Account</h4>
            <Link to="/subscribe">Plans</Link>
            <Link to="/account">Your account</Link>
          </div>
          <div>
            <h4>Company</h4>
            <Link to="/legal/about">About Us</Link>
            <Link to="/legal/grievance">Grievance</Link>
          </div>
          <div>
            <h4>Legal</h4>
            <Link to="/legal/terms">Terms &amp; Conditions</Link>
            <Link to="/legal/privacy">Privacy Policy</Link>
            <Link to="/legal/refund">Refund Policy</Link>
          </div>
        </nav>
      </div>
      <p className="ftr__copy">© SV Enterprises. All rights reserved.</p>
    </footer>
  );
}
